import "./AcrylicSignsAndCutting.module.css";
import Header from "@/reusable_sections/Header";
import AcrylicSignsHero from "./sections/AcrylicSignsHero";
import AcrylicSpecifications from "./sections/AcrylicSpecifications";
import ServiceCapabilities from "./sections/ServiceCapabilities";
import MaterialShowcase from "./sections/MaterialShowcase";
import IndustryApplications from "./sections/IndustryApplications";
import ServiceWorkflow from "./sections/ServiceWorkflow";
import AcrylicFaq from "./sections/AcrylicFaq";
import CustomProjectCTA from "./sections/CustomProjectCTA";
import RelatedServices from "./sections/RelatedServices";
import Footer from "@/reusable_sections/Footer";
export default function AcrylicSignsAndCuttingPage() {
  return <div>
      <Header />
      <AcrylicSignsHero />
      <AcrylicSpecifications />
      <ServiceCapabilities />
      <MaterialShowcase />
      <IndustryApplications />
      <ServiceWorkflow />
      <AcrylicFaq />
      <CustomProjectCTA />
      <RelatedServices />
      <Footer />
    </div>;
}